import React, { useState } from 'react';
import api from '../api/client';

export default function Login({ onLogin }){
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');

  async function submit(){
    setErr('');
    try {
      const { data } = await api.post('/auth/login', { username: u, password: p });
      if (data && data.token) {
        try { localStorage.setItem('token', data.token); } catch(e){}
        onLogin(data.token);
      } else {
        setErr('Login failed');
      }
    } catch(e){
      console.error('Login error', e);
      setErr(e?.response?.data?.message || 'Error');
    }
  }

  return (
    <div style={{border:'1px solid #ddd',padding:12,borderRadius:6}}>
      <div><label>Username</label><input value={u} onChange={e=>setU(e.target.value)} /></div>
      <div><label>Password</label><input type="password" value={p} onChange={e=>setP(e.target.value)} /></div>
      <div style={{marginTop:8}}>
        <button onClick={submit}>Login</button>
        {err && <div style={{color:'red'}}>{err}</div>}
      </div>
    </div>
  );
}
